import { React} from "react";
import { Outlet } from "react-router-dom";

const Layout = () => {

  return (
    <div className="m-0 flex flex-col p-0">
      <Outlet />
    </div>
          
  );
};

export default Layout;